"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const createPromise = (observableQuery) => {
    return new Promise(async (resolve) => {
        const subscription = observableQuery.subscribe((nextResult) => {
            if (!nextResult.loading) {
                subscription.unsubscribe();
                resolve();
                observableQuery.resultPromise = null;
            }
        });
    });
};
function getResultPromise(observableQuery) {
    if (observableQuery.resultPromise)
        return observableQuery.resultPromise;
    observableQuery.resultPromise = createPromise(observableQuery);
    return observableQuery.resultPromise;
}
exports.default = getResultPromise;
